import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation, Query } from "react-apollo";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import FrequencyField from "components/FrequencyField";
import FilterMenu from "components/FilterMenu";
import NotificationsRecipientField from "components/NotificationsRecipientField";
import gql from "graphql-tag";
import { updateDirtyStateMutation } from "mutations/updateDirtyStateMutation";
import RuleNameClickToEdit from "components/RuleNameClickToEdit";
import validateRuleName from "state/validateRuleName";
import t from "@zendesk/client-i18n-tools";
import CreateVerificationRuleMutation from "components/CreateVerificationRuleMutation";

import { Button } from "@zendeskgarden/react-buttons";

import styles from "./styles.css";
import FilterList from "components/FilterList";
import EditSplitButton from "components/EditSplitButton";

const dirtyStateQuery = gql`
  query {
    dirtyState @client {
      notificationRecipient
      ruleName
      frequency
    }
  }
`;

export default class EditForm extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    isDuplicate: PropTypes.bool,
  };

  render() {
    const { id, isDuplicate } = this.props;

    return (
      <Mutation mutation={updateDirtyStateMutation}>
        {mutate => (
          <Query query={dirtyStateQuery}>
            {({ data: { dirtyState } }) => (
              <div className={styles.container}>
                <div className={styles.header}>
                  <div className={styles.ruleNameContainer}>
                    <RuleNameClickToEdit
                      value={dirtyState.ruleName}
                      onSubmit={value => {
                        mutate({
                          variables: { data: { ruleName: value } },
                        });
                        return validateRuleName(value);
                      }}
                    />
                  </div>
                  {isDuplicate ? (
                    <CreateVerificationRuleMutation>
                      {mutate => (
                        <Button size="small" primary onClick={mutate}>
                          {t("knowledge-verification.create")}
                        </Button>
                      )}
                    </CreateVerificationRuleMutation>
                  ) : (
                    <EditSplitButton id={id} />
                  )}
                </div>
                <div className={styles.form}>
                  <div className={styles.dropdown}>
                    <FrequencyField
                      selectedKey={dirtyState.frequency}
                      onChange={key =>
                        mutate({ variables: { data: { frequency: key } } })
                      }
                    />
                  </div>
                  <Gap.Huge vertical />
                  <div className={styles.dropdown}>
                    <NotificationsRecipientField
                      value={dirtyState.notificationRecipient}
                      onChange={notificationRecipient =>
                        mutate({
                          variables: { data: { notificationRecipient } },
                        })
                      }
                    />
                  </div>
                  <Gap.Huge vertical />
                  <FilterMenu />
                  <Gap.Large vertical />
                  <FilterList removable />
                </div>
              </div>
            )}
          </Query>
        )}
      </Mutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditForm/index.js